import * as types from '../types/customerTypes';
import * as customerServices from '../../services/customerServices';

export function fetchCustomers(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CUSTOMERS_REQUEST });
    try {
      const data = await customerServices.fetchCustomers(params);
      const list = Array.isArray(data) ? data : (data.customers || data || []);
      dispatch({ type: types.FETCH_CUSTOMERS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_CUSTOMERS_FAILURE, payload: error.message });
    }
  };
}

export function fetchCustomerStats(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CUSTOMER_STATS_REQUEST });
    try {
      const data = await customerServices.fetchCustomerStats(params);
      dispatch({ type: types.FETCH_CUSTOMER_STATS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_CUSTOMER_STATS_FAILURE, payload: error.message });
    }
  };
}

export function fetchCustomerById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CUSTOMER_BY_ID_REQUEST });
    try {
      const data = await customerServices.getCustomerById(id);
      dispatch({ type: types.FETCH_CUSTOMER_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_CUSTOMER_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function fetchCustomerOrders(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CUSTOMER_ORDERS_REQUEST });
    try {
      const data = await customerServices.getCustomerOrderHistory(id);
      dispatch({ type: types.FETCH_CUSTOMER_ORDERS_SUCCESS, payload: Array.isArray(data) ? data : (data.orders || []) });
    } catch (error) {
      dispatch({ type: types.FETCH_CUSTOMER_ORDERS_FAILURE, payload: error.message });
    }
  };
}
